import {Stack, styled} from '@mui/material';

export const CustomStack = styled(Stack)`
	padding: 0 32px 24px;
	${({theme}) => theme.breakpoints.down('sm')} {
		padding: 16px;
	}
`;
